import React from 'react';
import {
    Card,
    CardContent,
    Typography,
} from '@mui/material';
import { Analytics } from '@mui/icons-material';

const EmptyState = ({ filteredData, allProgramCodes, selectedTab }) => {
    if (filteredData.length > 0) {
        return null;
    }

    return (
        <Card elevation={2} sx={{ py: 6, textAlign: 'center', borderRadius: 2 }}>
            <CardContent>
                <Analytics sx={{ fontSize: 48, color: 'text.secondary', mb: 1.5 }} />
                <Typography variant="h6" color="text.secondary" gutterBottom sx={{ fontSize: '1.1rem' }}>
                    No assessment data available
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                    {allProgramCodes.length > 0
                        ? `No data found for program: ${allProgramCodes[selectedTab]}`
                        : 'Please provide assessment data to view the dashboard'
                    }
                </Typography>
            </CardContent>
        </Card>
    );
};

export default EmptyState;